import { ILoggerService } from '../ports/logger-service.port'
import { useLogger } from '../infrastructure/script/logger/logger'

const logger = useLogger()
export const useLoggerServiceAdapter = (): ILoggerService => {
	return logger
}
